"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordBVHRequestT = exports.RecordBVHRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class RecordBVHRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsRecordBVHRequest(bb, obj) {
        return (obj || new RecordBVHRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsRecordBVHRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new RecordBVHRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    stop() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    path(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startRecordBVHRequest(builder) {
        builder.startObject(2);
    }
    static addStop(builder, stop) {
        builder.addFieldInt8(0, +stop, +false);
    }
    static addPath(builder, pathOffset) {
        builder.addFieldOffset(1, pathOffset, 0);
    }
    static endRecordBVHRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createRecordBVHRequest(builder, stop, pathOffset) {
        RecordBVHRequest.startRecordBVHRequest(builder);
        RecordBVHRequest.addStop(builder, stop);
        RecordBVHRequest.addPath(builder, pathOffset);
        return RecordBVHRequest.endRecordBVHRequest(builder);
    }
    unpack() {
        return new RecordBVHRequestT(this.stop(), this.path());
    }
    unpackTo(_o) {
        _o.stop = this.stop();
        _o.path = this.path();
    }
}
exports.RecordBVHRequest = RecordBVHRequest;
class RecordBVHRequestT {
    constructor(stop = false, path = null) {
        this.stop = stop;
        this.path = path;
    }
    pack(builder) {
        const path = (this.path !== null ? builder.createString(this.path) : 0);
        return RecordBVHRequest.createRecordBVHRequest(builder, this.stop, path);
    }
}
exports.RecordBVHRequestT = RecordBVHRequestT;
